import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import Typography from '@material-ui/core/Typography';
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import axios from "axios";
import {defaultVariabls} from "../../../../../config";
import {Translate} from "../../../../../config/Translate";
import SettingsRoundedIcon from '@material-ui/icons/SettingsRounded';
import SubTitle from "../../../../components/elements/SubTitle";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import TableContainer from "@material-ui/core/TableContainer/TableContainer";
import Paper from "@material-ui/core/Paper/Paper";
import Table from "@material-ui/core/Table/Table";
import TableBody from "@material-ui/core/TableBody/TableBody";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableRow from "@material-ui/core/TableRow/TableRow";
import Grid from "@material-ui/core/Grid/Grid";
import CurrencyFormat from "react-currency-format";
import {currencySymbol} from "../../../../../config/values";
import TextField from "@material-ui/core/TextField/TextField";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";

class OrderDetailsDialog extends React.Component{
    state = {
        open: false,
        loading:true,
        id: this.props.id,
        order: null,
        error: '',
        status:'',
    }
    componentDidMount(){
        this.loadData();
    }
    async componentDidUpdate(prevProps){
        if(this.state.id !== this.props.id){
            this.setState({
                loading:true,
                id: this.props.id,
                order: null,
                error: '',
                status:'',
            })
            await this.loadData();
        }
        if(this.state.loading){
            await this.loadData();
        }
    }
    handleRequest(){
        this.setState({
            loading:true,
        })
        let {status,error,id,order} = this.state;
        let data = new FormData();
        data.append('name', order.name);
        data.append('error', error);
        data.append('status', status);
        data.append('id', id ? id : 0);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/order/change_status`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.statusChanges, {
                    variant: 'success',
                });
                this.loadData();
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                });
                this.handleClose();
            });

    }
    async handleStart(){
        await this.setState({
            status: "start"
        })
        await this.handleRequest();
    }
    async handleCompleted(){
        await this.setState({
            status: "completed"
        })
        await this.handleRequest();
    }
    async handeleHasError(){
        await this.setState({
            status: "has_error"
        })
        await this.handleRequest();
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/order/get/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        loading: false,
                        order: response.data,
                        error: response.data.error,
                        status: response.data.status
                    })
                }).catch(error => {
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }
    handleOpen(){
        this.setState({
            open:true,
        })
    }
    async handleClose(){
        await this.setState({
            open:false,
            loading:true,
            order: null,
            error: '',
            status:'',
        });
        await this.props.reload();
    }

    render(){
        let {open,loading,order,error} = this.state;
        return (
            <div>
                <Button
                    size="small"
                    color="primary"
                    onClick={this.handleOpen.bind(this)}
                    startIcon={<SettingsRoundedIcon/>}
                >
                    {Translate.manage}
                </Button>
                <Dialog
                    onClose={this.handleClose.bind(this)}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.handleClose.bind(this)}>
                        <SubTitle>
                            {Translate.manageOrder}
                        </SubTitle>
                    </DialogTitle>
                    {
                        loading ?
                            <DialogContent>
                                <AppCardLoaderFields/>
                            </DialogContent>
                            :
                            <>
                                <DialogContent>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.username}
                                                    </TableCell>
                                                    <TableCell align="right">{order.user.name}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.orderName}
                                                    </TableCell>
                                                    <TableCell align="right">{order.name}</TableCell>
                                                </TableRow>
                                                {/*<TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.status}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            order.status === "not_payed" ?
                                                                <Typography
                                                                    color="textSecondary">{Translate.not_payed}</Typography> :
                                                                order.status === "payed" ?
                                                                    <Typography
                                                                        color="textSecondary">{Translate.is_payed}</Typography> :
                                                                    order.status === "waiting" ?
                                                                        <Typography
                                                                            color="primary">{Translate.waiting}</Typography> :
                                                                        order.status === "has_error" ?
                                                                            <Typography
                                                                                style={{color: '#f66c64'}}>{Translate.has_error}</Typography> :
                                                                            order.status === "start" ?
                                                                                <Typography
                                                                                    color="primary">{Translate.start}</Typography> :
                                                                                order.status === "completed" ?
                                                                                    <Typography
                                                                                        style={{color: '#27da57'}}>{Translate.completed}</Typography> : null
                                                        }
                                                    </TableCell>
                                                </TableRow>*/}
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.totalPrice}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <CurrencyFormat value={order.total_price} displayType={'text'}
                                                                        thousandSeparator={true}
                                                                        suffix={" " + currencySymbol}/>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.payment}
                                                    </TableCell>
                                                    <TableCell
                                                        align="right">{order.gateway.name} / {order.payed_money} {order.currency}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.products}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            order.safecoins.map((product, key) => (
                                                                <React.Fragment index={key}>
                                                                    <Grid item xs={12} className="ml-10">
                                                                        <Typography>
                                                                            <strong
                                                                                className="counts">{product.count}K</strong> Safe
                                                                            3.0
                                                                            Coins {product.category.name} - <CurrencyFormat
                                                                            value={product.price} displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            suffix={" " + currencySymbol}/>
                                                                        </Typography>
                                                                    </Grid>
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.originEmail}
                                                    </TableCell>
                                                    <TableCell align="right">{order.email}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.originPassword}
                                                    </TableCell>
                                                    <TableCell align="right">{order.password}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.current_coin_amount}
                                                    </TableCell>
                                                    <TableCell align="right">{order.current_amount}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.backup_codes}
                                                    </TableCell>
                                                    <TableCell
                                                        align="right">{order.backup_1} {!!order.backup_2 && " - " + order.backup_2} {!!order.backup_3 && " - " + order.backup_3} {!!order.backup_4 && " - " + order.backup_4} </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </DialogContent>
                                <DialogActions style={{background: "#f3f3f3"}}>
                                    <TableContainer >
                                        <Table>
                                            <TableBody>
                                                {
                                                    order.status !== 'completed' &&
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <TextField
                                                                select
                                                                fullWidth
                                                                size="small"
                                                                label={Translate.selectErrorType}
                                                                value={error}
                                                                onChange={(e) => this.setState({error: e.target.value})}
                                                                variant="outlined"
                                                            >
                                                                <MenuItem value="no-login-verification">
                                                                    {Translate.nologinverification}
                                                                </MenuItem>
                                                                <MenuItem value="market-locked">
                                                                    {Translate.marketlocked}
                                                                </MenuItem>
                                                                <MenuItem value="wrong-password">
                                                                    {Translate.wrongpassword}
                                                                </MenuItem>
                                                                <MenuItem value="wrong-backup">
                                                                    {Translate.wrongbackup}
                                                                </MenuItem>
                                                            </TextField>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Button
                                                                autoFocus
                                                                onClick={this.handeleHasError.bind(this)}
                                                                color="secondary"
                                                                variant="contained"
                                                                size="small"
                                                            >
                                                                {Translate.submitError}
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        {Translate.status}:
                                                        {
                                                            order.status === "not_payed" ?
                                                                <Typography
                                                                    color="textSecondary">{Translate.not_payed}</Typography> :
                                                                order.status === "payed" ?
                                                                    <Typography
                                                                        color="textSecondary">{Translate.is_payed}</Typography> :
                                                                    order.status === "waiting" ?
                                                                        <Typography
                                                                            color="primary">{Translate.waiting}</Typography> :
                                                                        order.status === "has_error" ?
                                                                            <Typography
                                                                                style={{color: '#f66c64'}}>
                                                                                {Translate.has_error} / {Translate[order.error.replace("-", "").replace("-", "")]}
                                                                                </Typography> :
                                                                            order.status === "start" ?
                                                                                <Typography
                                                                                    color="primary">{Translate.start}</Typography> :
                                                                                order.status === "completed" ?
                                                                                    <Typography
                                                                                        style={{color: '#27da57'}}>{Translate.completed}</Typography> : null
                                                        }
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {
                                                            order.status === "waiting" || order.status === "has_error" ?
                                                                <Button
                                                                    autoFocus
                                                                    onClick={this.handleStart.bind(this)}
                                                                    color="primary"
                                                                    size="small"
                                                                    variant="contained"
                                                                >
                                                                    {Translate.confirmStart}
                                                                </Button>
                                                                :
                                                                order.status === "start" ?
                                                                <Button
                                                                    autoFocus
                                                                    onClick={this.handleCompleted.bind(this)}
                                                                    color="primary"
                                                                    size="small"
                                                                    variant="contained"
                                                                >
                                                                    {Translate.confirmCompleted}
                                                                </Button> : null
                                                        }

                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </DialogActions>
                            </>
                    }
                </Dialog>
            </div>
        );
    }
}

const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(OrderDetailsDialog)))));